// extracted by mini-css-extract-plugin
export default {"modalRow":"styles_modalRow__HHEeH","modalInfoBadge":"styles_modalInfoBadge__cn11J","historicIcon":"styles_historicIcon__GilUL","loaadMoreBtn":"styles_loaadMoreBtn__neVLZ"};